import moment from 'moment';
import EventBus from 'eventing-bus';
import Masonry from 'react-masonry-css';
import { Link } from 'react-router-dom';
import Switch from '@mui/material/Switch';
import { useHistory } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox, CircularProgress } from '@mui/material';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { Box, TextField, FormControl, Select, MenuItem, Chip, Menu, ListItemIcon, ListItemText, Typography, Button, Popover, IconButton } from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon, PlayArrow as PlayIcon, ContentCopy as CopyIcon, MoreVert as MoreIcon, Schedule as ScheduleIcon, CheckCircle as ActiveIcon, PauseCircle as PausedIcon, Archive as ArchiveIcon, Lock as DraftIcon, LocalOffer as TagIcon, FilterList as FilterIcon, Upload as UploadIcon, ArrowDropDown as ArrowDropDownIcon } from '@mui/icons-material';

import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import WorkflowScheduler from './WorkflowScheduler';
import TitleRoute from '../../components/titleRoute.js';
import ViewStateManager from '../../utils/viewStateManager';
import { getWorkspacePath } from '../../utils/workspaceUtils';
import { getAllWorkflows, deleteWorkflow, batchDeleteWorkflows, setWorkflowBuilderModal, cloneWorkflow, executeWorkflow, setSelectedWorkflow, getWorkspaceAnalytics, updateWorkflow, importWorkflow } from '../../store/Workflows';
import TagsManager from '../../components/Tags/TagsManager';
import { color, display, fontSize, fontWeight, gap, minHeight } from '../../../node_modules/@mui/system/index';
import TableAnimationFiles from '../../components/Animations/TableAnimationFiles.js';
import notFoundImg from '../../static/img/not-found.png';

// Utility function to get contrast text color based on background
const getContrastTextColor = (hexColor) => {
  // Convert hex to RGB
  const hex = hexColor?.replace('#', '') || '6B7280';
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Calculate luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Return black for light colors, white for dark colors
  return luminance > 0.5 ? '#000000' : '#FFFFFF';
};

// Node type icons and colors mapping
const NODE_TYPE_CONFIGS = {
  trigger: {
    icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6.21507 1.8813C1.73639 3.96974 -0.206425 9.3076 1.88201 13.7863C2.71316 15.5687 4.06849 16.9963 5.80306 17.9161C6.10809 18.0773 6.48419 17.9571 6.64538 17.652C6.80657 17.347 6.69391 16.9674 6.38888 16.8062C4.90045 16.0199 3.72983 14.7912 3.0149 13.258C1.21877 9.40619 2.89153 4.81032 6.74334 3.01419C10.5951 1.21806 15.191 2.89082 16.9871 6.74263C18.7833 10.5944 17.1105 15.1903 13.2587 16.9864C12.949 17.1308 12.812 17.5074 12.9564 17.817C13.1008 18.1267 13.4773 18.2637 13.787 18.1193C18.2656 16.0309 20.2085 10.693 18.12 6.21436C16.0316 1.73569 10.6937 -0.207134 6.21507 1.8813Z" fill="white" /> <path d="M5.59665 5.56493C3.15303 7.99119 3.13887 11.9601 5.56512 14.4037C5.79809 14.6383 6.18586 14.6397 6.42049 14.4068C6.65512 14.1738 6.65651 13.786 6.42354 13.5514C4.46322 11.577 4.47461 8.38368 6.44897 6.42335C8.42333 4.46303 11.6167 4.47442 13.577 6.44878C15.5373 8.42314 15.5259 11.6165 13.5516 13.5768C13.317 13.8098 13.3156 14.1976 13.5485 14.4322C13.7815 14.6668 14.1693 14.6682 14.4039 14.4352C16.8475 12.009 16.8617 8.04009 14.4354 5.59646C12.0092 3.15284 8.04028 3.13868 5.59665 5.56493Z" fill="white" /><circle cx="10" cy="9.5" r="3" fill="white" /></svg>,
    color: '#A1D36E',
    label: 'Trigger'
  },
  agent: {
    icon: <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0784 14.7194C19.9785 15.789 19.641 16.7644 19.0031 17.6185C17.8657 19.1404 16.3431 19.9588 14.4394 19.9824C12.2146 20.0095 9.98909 20.0009 7.7636 19.9859C4.84741 19.9667 2.43497 17.754 2.13101 14.8471C2.12673 14.8043 2.1146 14.7622 2.10746 14.7244C0.792433 14.4632 0.069629 13.7683 0.00469798 12.7008C-0.033119 12.0851 0.157393 11.5442 0.57552 11.0875C0.986512 10.6387 1.51381 10.4325 2.11317 10.3854C2.20522 9.3501 2.51917 8.41252 3.10997 7.58412C4.26374 5.96726 5.84635 5.14029 7.83138 5.10318C8.66764 5.08748 9.5046 5.10033 10.3416 5.10033C10.4386 5.10033 10.5357 5.10033 10.6719 5.10033C10.6719 4.81777 10.6719 4.55377 10.6719 4.28976C10.6719 3.85379 10.6648 3.41712 10.6755 2.98115C10.6798 2.81918 10.6355 2.73641 10.4793 2.66006C9.86636 2.36181 9.56882 1.70108 9.73079 1.05177C9.88634 0.429575 10.4536 -0.00424976 11.1065 3.14058e-05C11.7679 0.00431257 12.3152 0.447413 12.4679 1.10172C12.612 1.71963 12.3045 2.35253 11.7165 2.66648C11.6416 2.70644 11.5824 2.78279 11.531 2.85343C11.5096 2.88268 11.5267 2.93977 11.5267 2.98472C11.5267 3.67755 11.5267 4.36968 11.5267 5.09961C11.6509 5.09961 11.7544 5.0989 11.8571 5.09961C12.8803 5.11103 13.9064 5.07749 14.926 5.14243C17.4697 5.30582 19.7166 7.46853 20.0291 10.0015C20.0441 10.1243 20.0641 10.247 20.0812 10.3633C21.5818 10.7729 22.2411 11.4878 22.1826 12.6323C22.1269 13.7661 21.382 14.5125 20.0784 14.7194ZM11.0929 19.1347C12.1696 19.1347 13.2463 19.1404 14.3231 19.1333C17.1001 19.1154 19.22 16.9948 19.2328 14.2242C19.2378 13.1033 19.24 11.9816 19.2293 10.8606C19.2264 10.5331 19.205 10.1999 19.1387 9.88025C18.6563 7.54131 16.707 5.96441 14.2888 5.95513C12.251 5.94729 10.2131 5.95228 8.1753 5.95513C7.88204 5.95585 7.58807 5.96798 7.29624 5.99081C5.13568 6.16277 3.1592 8.05362 3.00936 10.2163C2.90947 11.6512 2.97083 13.0968 2.96512 14.5382C2.96441 14.7058 2.98796 14.8757 3.01864 15.0419C3.46388 17.49 5.42109 19.1261 7.91629 19.134C8.97445 19.1383 10.0333 19.1347 11.0929 19.1347ZM20.1091 11.2909C20.1091 12.1357 20.1091 12.9812 20.1091 13.8275C20.8604 13.7775 21.3884 13.1696 21.3278 12.4447C21.2728 11.7775 20.7056 11.2381 20.1091 11.2909ZM2.07036 13.8303C2.07036 12.967 2.07036 12.1214 2.07036 11.2752C1.39679 11.3016 0.872348 11.8446 0.855223 12.5103C0.838098 13.2046 1.34399 13.7618 2.07036 13.8303ZM11.0908 0.856978C10.7897 0.859119 10.5528 1.09387 10.5492 1.39426C10.5456 1.70536 10.7904 1.94939 11.1029 1.94582C11.4054 1.94297 11.6395 1.70964 11.6438 1.40854C11.6473 1.09744 11.4047 0.854838 11.0908 0.856978Z" fill="white" /><path d="M11.0868 16.6406C9.91232 16.6406 8.73786 16.6428 7.56339 16.6399C5.78742 16.6364 4.60011 15.4498 4.59797 13.6781C4.59726 12.9039 4.59512 12.1297 4.59868 11.3555C4.60582 9.65735 5.81596 8.45149 7.51487 8.45078C9.89948 8.44935 12.2841 8.44935 14.6694 8.45078C16.3783 8.45149 17.5763 9.63666 17.5877 11.3463C17.5934 12.236 17.6056 13.1265 17.5749 14.0156C17.5278 15.3998 16.3648 16.5836 14.9855 16.6221C13.6876 16.6585 12.3876 16.6299 11.0882 16.6299C11.0868 16.6335 11.0868 16.6371 11.0868 16.6406ZM11.0811 15.7858C12.2912 15.7858 13.5007 15.7915 14.7101 15.7844C15.9081 15.7766 16.7194 14.9689 16.7308 13.7758C16.7386 12.9574 16.7379 12.139 16.7308 11.3206C16.7201 10.1169 15.8945 9.3063 14.6865 9.30558C12.2934 9.30416 9.90091 9.30416 7.50774 9.30558C6.28118 9.3063 5.45634 10.1361 5.45278 11.3705C5.45064 12.1354 5.45206 12.9003 5.45278 13.6652C5.45349 14.9753 6.25407 15.7823 7.55911 15.7844C8.73286 15.7873 9.90662 15.7858 11.0811 15.7858Z" fill="white" /><path d="M8.34185 14.3346C7.35504 14.3303 6.56445 13.5362 6.56445 12.5487C6.56445 11.5519 7.37145 10.7456 8.36397 10.752C9.34293 10.7584 10.1449 11.5647 10.1464 12.5437C10.1471 13.5383 9.34079 14.3382 8.34185 14.3346ZM8.3183 13.4784C8.84846 13.4927 9.28299 13.0831 9.29084 12.5608C9.29869 12.0506 8.88556 11.6211 8.37467 11.6075C7.86593 11.594 7.43139 12.0092 7.41997 12.5187C7.40856 13.041 7.80456 13.4641 8.3183 13.4784Z" fill="white" /><path d="M13.846 14.3346C12.8464 14.3382 12.0465 13.5383 12.0508 12.5401C12.0551 11.5554 12.8521 10.7555 13.8325 10.752C14.8193 10.7484 15.6406 11.569 15.6348 12.5529C15.6299 13.5354 14.8307 14.331 13.846 14.3346ZM13.8418 13.4784C14.3562 13.4769 14.7765 13.0609 14.7786 12.5501C14.7808 12.0349 14.3384 11.5975 13.8225 11.6075C13.3109 11.6168 12.902 12.0406 12.9063 12.5558C12.9113 13.0759 13.3209 13.4798 13.8418 13.4784Z" fill="white" /></svg>,
    color: '#0FA763',
    label: 'AI Agent'
  },
  decision: {
    icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.99967 10.6248C7.35801 10.6248 5.20801 8.47484 5.20801 5.83317C5.20801 3.1915 7.35801 1.0415 9.99967 1.0415C12.6413 1.0415 14.7913 3.1915 14.7913 5.83317C14.7913 8.47484 12.6413 10.6248 9.99967 10.6248ZM9.99967 2.2915C8.04967 2.2915 6.45801 3.88317 6.45801 5.83317C6.45801 7.78317 8.04967 9.37484 9.99967 9.37484C11.9497 9.37484 13.5413 7.78317 13.5413 5.83317C13.5413 3.88317 11.9497 2.2915 9.99967 2.2915Z" fill="white" /><path d="M2.8418 18.9583C2.50013 18.9583 2.2168 18.675 2.2168 18.3333C2.2168 14.775 5.70846 11.875 10.0001 11.875C10.8418 11.875 11.6668 11.9834 12.4668 12.2084C12.8001 12.3 12.9918 12.6417 12.9001 12.975C12.8085 13.3083 12.4668 13.5 12.1335 13.4084C11.4501 13.2167 10.7335 13.125 10.0001 13.125C6.40013 13.125 3.4668 15.4583 3.4668 18.3333C3.4668 18.675 3.18346 18.9583 2.8418 18.9583Z" fill="white" /><path d="M15.0003 18.9582C13.617 18.9582 12.317 18.2248 11.617 17.0332C11.242 16.4332 11.042 15.7248 11.042 14.9998C11.042 13.7832 11.5837 12.6582 12.5253 11.9082C13.2253 11.3498 14.1087 11.0415 15.0003 11.0415C17.1837 11.0415 18.9587 12.8165 18.9587 14.9998C18.9587 15.7248 18.7587 16.4332 18.3837 17.0415C18.1753 17.3915 17.9086 17.7082 17.592 17.9748C16.9003 18.6082 15.9753 18.9582 15.0003 18.9582ZM15.0003 12.2915C14.3837 12.2915 13.8003 12.4998 13.3087 12.8915C12.667 13.3998 12.292 14.1748 12.292 14.9998C12.292 15.4915 12.4253 15.9748 12.6837 16.3915C13.167 17.2082 14.0587 17.7082 15.0003 17.7082C15.6587 17.7082 16.292 17.4665 16.7753 17.0332C16.992 16.8498 17.1753 16.6332 17.3086 16.3998C17.5753 15.9748 17.7087 15.4915 17.7087 14.9998C17.7087 13.5082 16.492 12.2915 15.0003 12.2915Z" fill="white" /><path d="M14.5251 16.4501C14.3667 16.4501 14.2084 16.3918 14.0834 16.2668L13.2584 15.4418C13.0167 15.2002 13.0167 14.8001 13.2584 14.5584C13.5001 14.3168 13.9001 14.3168 14.1417 14.5584L14.5417 14.9585L15.8751 13.7251C16.1251 13.4918 16.525 13.5085 16.7584 13.7585C16.9917 14.0085 16.9751 14.4085 16.7251 14.6418L14.9501 16.2835C14.8251 16.3918 14.6751 16.4501 14.5251 16.4501Z" fill="white" /></svg>,
    color: '#AC94EA',
    label: 'Decision'
  },
  crm: {
    icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5003 18.9582H7.50033C2.97533 18.9582 1.04199 17.0248 1.04199 12.4998V7.49984C1.04199 2.97484 2.97533 1.0415 7.50033 1.0415H12.5003C17.0253 1.0415 18.9587 2.97484 18.9587 7.49984V12.4998C18.9587 17.0248 17.0253 18.9582 12.5003 18.9582ZM7.50033 2.2915C3.65866 2.2915 2.29199 3.65817 2.29199 7.49984V12.4998C2.29199 16.3415 3.65866 17.7082 7.50033 17.7082H12.5003C16.342 17.7082 17.7087 16.3415 17.7087 12.4998V7.49984C17.7087 3.65817 16.342 2.2915 12.5003 2.2915H7.50033Z" fill="white" /><path d="M6.10875 12.7C5.97542 12.7 5.84209 12.6583 5.72542 12.5667C5.45042 12.3583 5.40042 11.9667 5.60875 11.6917L7.59209 9.11667C7.83375 8.80834 8.17542 8.60834 8.56709 8.55834C8.95042 8.50834 9.34209 8.61667 9.65042 8.85834L11.1754 10.0583C11.2338 10.1083 11.2921 10.1083 11.3338 10.1C11.3671 10.1 11.4254 10.0833 11.4754 10.0167L13.4004 7.53334C13.6088 7.25834 14.0088 7.20834 14.2754 7.42501C14.5504 7.63334 14.6004 8.02501 14.3838 8.30001L12.4588 10.7833C12.2171 11.0917 11.8754 11.2917 11.4838 11.3333C11.0921 11.3833 10.7088 11.275 10.4004 11.0333L8.87542 9.83334C8.81709 9.78334 8.75042 9.78334 8.71709 9.79167C8.68375 9.79167 8.62542 9.80834 8.57542 9.87501L6.59209 12.45C6.48375 12.6167 6.30042 12.7 6.10875 12.7Z" fill="white" /></svg>,
    color: '#673AB7',
    label: 'CRM'
  },
  communication: {
    icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.9163 9.375H7.08301C6.74134 9.375 6.45801 9.09167 6.45801 8.75C6.45801 8.40833 6.74134 8.125 7.08301 8.125H12.9163C13.258 8.125 13.5413 8.40833 13.5413 8.75C13.5413 9.09167 13.258 9.375 12.9163 9.375Z" fill="white" /><path d="M13.3337 18.5999C13.0503 18.5999 12.767 18.5166 12.5253 18.3582L8.97532 15.9915H5.83366C2.96699 15.9915 1.04199 14.0665 1.04199 11.1999V6.19987C1.04199 3.3332 2.96699 1.4082 5.83366 1.4082H14.167C17.0337 1.4082 18.9587 3.3332 18.9587 6.19987V11.1999C18.9587 13.8499 17.3087 15.6999 14.792 15.9582V17.1415C14.792 17.6832 14.5003 18.1749 14.0253 18.4249C13.8086 18.5415 13.567 18.5999 13.3337 18.5999ZM5.83366 2.64986C3.68366 2.64986 2.29199 4.04153 2.29199 6.19153V11.1915C2.29199 13.3415 3.68366 14.7332 5.83366 14.7332H9.16699C9.29199 14.7332 9.40867 14.7665 9.517 14.8415L13.2253 17.3082C13.317 17.3666 13.4003 17.3416 13.442 17.3166C13.4837 17.2916 13.5503 17.2415 13.5503 17.1332V15.3582C13.5503 15.0165 13.8337 14.7332 14.1753 14.7332C16.3253 14.7332 17.717 13.3415 17.717 11.1915V6.19153C17.717 4.04153 16.3253 2.64986 14.1753 2.64986H5.83366Z" fill="white" /></svg>,
    color: '#10A37F',
    label: 'Communication'
  },
  data: {
    icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.82565 9.89967C9.37565 9.89967 8.91732 9.81634 8.55898 9.65801L3.64232 7.47467C2.39232 6.91634 2.20898 6.16634 2.20898 5.75801C2.20898 5.34967 2.39232 4.59967 3.64232 4.04134L8.55898 1.85801C9.28398 1.53301 10.3757 1.53301 11.1007 1.85801L16.0257 4.04134C17.2673 4.59134 17.459 5.34967 17.459 5.75801C17.459 6.16634 17.2757 6.91634 16.0257 7.47467L11.1007 9.65801C10.734 9.82467 10.284 9.89967 9.82565 9.89967ZM9.82565 2.86634C9.54232 2.86634 9.26732 2.90801 9.06732 2.99967L4.15065 5.18301C3.64232 5.41634 3.45898 5.64967 3.45898 5.75801C3.45898 5.86634 3.64232 6.10801 4.14232 6.33301L9.05898 8.51634C9.45898 8.69134 10.184 8.69134 10.584 8.51634L15.509 6.33301C16.0173 6.10801 16.2007 5.86634 16.2007 5.75801C16.2007 5.64967 16.0173 5.40801 15.509 5.18301L10.5923 2.99967C10.3923 2.91634 10.109 2.86634 9.82565 2.86634Z" fill="white" /><path d="M10 14.242C9.68333 14.242 9.36667 14.1753 9.06667 14.042L3.40833 11.5253C2.55 11.1503 1.875 10.1087 1.875 9.16699C1.875 8.82533 2.15833 8.54199 2.5 8.54199C2.84167 8.54199 3.125 8.82533 3.125 9.16699C3.125 9.62533 3.5 10.2003 3.91667 10.392L9.575 12.9087C9.84167 13.0253 10.15 13.0253 10.425 12.9087L16.0833 10.392C16.5 10.2087 16.875 9.62533 16.875 9.16699C16.875 8.82533 17.1583 8.54199 17.5 8.54199C17.8417 8.54199 18.125 8.82533 18.125 9.16699C18.125 10.1087 17.45 11.1503 16.5917 11.5337L10.9333 14.0503C10.6333 14.1753 10.3167 14.242 10 14.242Z" fill="white" /><path d="M10 18.408C9.68333 18.408 9.36667 18.3414 9.06667 18.208L3.40833 15.6914C2.475 15.2747 1.875 14.3497 1.875 13.3247C1.875 12.983 2.15833 12.6997 2.5 12.6997C2.84167 12.6997 3.125 12.9914 3.125 13.333C3.125 13.858 3.43333 14.3414 3.91667 14.558L9.575 17.0747C9.84167 17.1914 10.15 17.1914 10.425 17.0747L16.0833 14.558C16.5667 14.3414 16.875 13.8664 16.875 13.333C16.875 12.9914 17.1583 12.708 17.5 12.708C17.8417 12.708 18.125 12.9914 18.125 13.333C18.125 14.358 17.525 15.283 16.5917 15.6997L10.9333 18.2164C10.6333 18.3414 10.3167 18.408 10 18.408Z" fill="white" /></svg>,
    color: '#C73A63',
    label: 'Data'
  },
  wait: {
    icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.0007 18.9582C5.05898 18.9582 1.04232 14.9415 1.04232 9.99984C1.04232 5.0582 5.05898 1.04154 10.0007 1.04154C14.9423 1.04154 18.959 5.0582 18.959 9.99984C18.959 14.9415 14.9423 18.9582 10.0007 18.9582ZM10.0007 2.29154C5.75065 2.29154 2.29232 5.75817 2.29232 9.99984C2.29232 14.2415 5.75065 17.7082 10.0007 17.7082C14.2507 17.7082 17.709 14.2415 17.709 9.99984C17.709 5.75817 14.2507 2.29154 10.0007 2.29154Z" fill="white" /><path d="M13.5756 12.5832C13.4256 12.5832 13.2756 12.5332 13.1589 12.4249L10.2339 9.49988C10.0089 9.27488 9.88391 8.97488 9.88391 8.65821V5.41654C9.88391 5.07488 10.1672 4.79154 10.5089 4.79154C10.8506 4.79154 11.1339 5.07488 11.1339 5.41654V8.65821L13.9839 11.5082C14.2256 11.7499 14.2256 12.1582 13.9839 12.3999C13.8672 12.5249 13.7172 12.5832 13.5756 12.5832Z" fill="white" /></svg>,
    color: '#007EE5',
    label: 'Wait'
  },
  integration: {
    icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.50065 18.9582H12.5007C17.0257 18.9582 18.959 17.0248 18.959 12.4998V7.49984C18.959 2.97484 17.0257 1.0415 12.5007 1.0415H7.50065C2.97565 1.0415 1.04232 2.97484 1.04232 7.49984V12.4998C1.04232 17.0248 2.97565 18.9582 7.50065 18.9582ZM7.50065 2.2915H12.5007C16.3423 2.2915 17.709 3.65817 17.709 7.49984V12.4998C17.709 16.3415 16.3423 17.7082 12.5007 17.7082H7.50065C3.65898 17.7082 2.29232 16.3415 2.29232 12.4998V7.49984C2.29232 3.65817 3.65898 2.2915 7.50065 2.2915Z" fill="white" /><path d="M8.54232 12.2832H6.04232C5.70065 12.2832 5.41732 11.9999 5.41732 11.6582C5.41732 11.3165 5.70065 11.0332 6.04232 11.0332H8.54232C8.88398 11.0332 9.16732 11.3165 9.16732 11.6582C9.16732 11.9999 8.88398 12.2832 8.54232 12.2832Z" fill="white" /><path d="M13.959 8.9668H11.459C11.1173 8.9668 10.834 8.68346 10.834 8.3418C10.834 8.00013 11.1173 7.7168 11.459 7.7168H13.959C14.3007 7.7168 14.584 8.00013 14.584 8.3418C14.584 8.68346 14.3007 8.9668 13.959 8.9668Z" fill="white" /><path d="M8.95898 8.9668C8.61732 8.9668 8.33398 8.68346 8.33398 8.3418V5.8418C8.33398 5.50013 8.61732 5.2168 8.95898 5.2168C9.30065 5.2168 9.58398 5.50013 9.58398 5.8418V8.3418C9.58398 8.68346 9.30065 8.9668 8.95898 8.9668Z" fill="white" /><path d="M11.041 14.7832C10.6993 14.7832 10.416 14.4999 10.416 14.1582V11.6582C10.416 11.3165 10.6993 11.0332 11.041 11.0332C11.3827 11.0332 11.666 11.3165 11.666 11.6582V14.1582C11.666 14.4999 11.3827 14.7832 11.041 14.7832Z" fill="white" /></svg>,
    color: '#F44336',
    label: 'Integration'
  },
  human: {
    icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.99967 10.6248C7.35801 10.6248 5.20801 8.47484 5.20801 5.83317C5.20801 3.1915 7.35801 1.0415 9.99967 1.0415C12.6413 1.0415 14.7913 3.1915 14.7913 5.83317C14.7913 8.47484 12.6413 10.6248 9.99967 10.6248ZM9.99967 2.2915C8.04967 2.2915 6.45801 3.88317 6.45801 5.83317C6.45801 7.78317 8.04967 9.37484 9.99967 9.37484C11.9497 9.37484 13.5413 7.78317 13.5413 5.83317C13.5413 3.88317 11.9497 2.2915 9.99967 2.2915Z" fill="white" /><path d="M17.5003 18.9582C17.1587 18.9582 16.8753 18.6749 16.8753 18.3332C16.8753 14.7749 13.5587 11.8749 9.9987 11.8749C6.43537 11.8749 3.1237 14.7832 3.1237 18.3332C3.1237 18.6749 2.84037 18.9582 2.4987 18.9582C2.15703 18.9582 1.8737 18.6749 1.8737 18.3332C1.8737 14.0916 5.74203 10.6249 9.9987 10.6249C14.2553 10.6249 18.1237 14.0916 18.1237 18.3332C18.1237 18.6749 17.8403 18.9582 17.5003 18.9582Z" fill="white" /></svg>,
    color: '#00BCD4',
    label: 'Human'
  },
  llm: {
    icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5003 18.9582H7.50033C2.97533 18.9582 1.04199 17.0248 1.04199 12.4998V7.49984C1.04199 2.97484 2.97533 1.0415 7.50033 1.0415H12.5003C17.0253 1.0415 18.9587 2.97484 18.9587 7.49984V12.4998C18.9587 17.0248 17.0253 18.9582 12.5003 18.9582ZM7.50033 2.2915C3.65866 2.2915 2.29199 3.65817 2.29199 7.49984V12.4998C2.29199 16.3415 3.65866 17.7082 7.50033 17.7082H12.5003C16.342 17.7082 17.7087 16.3415 17.7087 12.4998V7.49984C17.7087 3.65817 16.342 2.2915 12.5003 2.2915H7.50033Z" fill="white" /><path d="M7.08398 8.12484C6.74232 8.12484 6.45898 7.8415 6.45898 7.49984C6.45898 7.15817 6.74232 6.87484 7.08398 6.87484H12.9173C13.259 6.87484 13.5423 7.15817 13.5423 7.49984C13.5423 7.8415 13.259 8.12484 12.9173 8.12484H7.08398Z" fill="white" /><path d="M7.08398 13.1248C6.74232 13.1248 6.45898 12.8415 6.45898 12.4998C6.45898 12.1582 6.74232 11.8748 7.08398 11.8748H10.209C10.5507 11.8748 10.834 12.1582 10.834 12.4998C10.834 12.8415 10.5507 13.1248 10.209 13.1248H7.08398Z" fill="white" /></svg>,
    color: '#E91E63',
    label: 'LLM'
  }
};

// Utility function to get node type config
const getNodeTypeConfig = (nodeType) => {
  return NODE_TYPE_CONFIGS[nodeType] || {
    icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="8" fill="white" /></svg>,
    color: '#9CA3AF',
    label: nodeType || 'Unknown'
  };
};

// Function to render dynamic node icons based on workflow nodes
const renderDynamicNodeIcons = (workflow) => {
  if (!workflow.nodes || workflow.nodes.length === 0) {
    return null;
  }

  // Display up to 5 node icons, showing each instance
  const maxIconsToShow = 5;
  const nodesToShow = workflow.nodes.slice(0, maxIconsToShow);
  const remainingCount = workflow.nodes.length - maxIconsToShow;

  return (
    <div className='nodes-box'>
      {nodesToShow.map((node, index) => {
        const config = getNodeTypeConfig(node.type);
        return (
          <span
            key={`${node.id || index}`}
            className='icon'
            style={{ backgroundColor: config.color }}
            title={`${config.label}${node.name ? `: ${node.name}` : ''}`}
          >
            {config.icon}
          </span>
        );
      })}
      {remainingCount > 0 && (
        <span
          className='more-count'
          title={`+${remainingCount} more nodes`}
          style={{
            fontSize: '11px',
            color: '#666',
            marginLeft: '4px',
            fontWeight: '500'
          }}
        >
          +{remainingCount}
        </span>
      )}
    </div>
  );
};

const Workflows = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const breakpoints = { default: 3, 991: 2, 700: 1 };

  // Load saved view state
  const savedViewState = ViewStateManager.getWorkflowView();
  const [isTableView, setTableView] = useState(savedViewState?.isTableView ?? true);

  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [selectedType, setSelectedType] = useState('all');
  const [selectedStatus, setSelectedStatus] = useState('all');
  const [selectedTags, setSelectedTags] = useState([]);
  const [tagsFilterAnchor, setTagsFilterAnchor] = useState(null);
  const [cloneModal, setCloneModal] = useState(false);
  const [newName, setNewName] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [workflowToDelete, setWorkflowToDelete] = useState(null);
  const [workflowsToDelete, setWorkflowsToDelete] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuWorkflow, setMenuWorkflow] = useState(null);
  const [isWorkflowOpen, setIsWorkflowOpen] = useState(false);
  const [scheduleWorkflowModal, setScheduleWorkflow] = useState(false);
  const [scheduleDialog, setScheduleDialog] = useState(false);
  const [importLoading, setImportLoading] = useState(false);
  const [createMenuAnchor, setCreateMenuAnchor] = useState(null);
  const fileInputRef = useRef(null);

  const { allWorkflows, workflowsLoading, workflowBuilderModal, workflowExecutionModal, filters, workspaceAnalytics, analyticsLoading } = useSelector(state => state.Workflows);

  const { currentWorkspace } = useSelector(state => state.Settings);
  const { workflows: workflowsObjectState } = useSelector(state => state.Objects);

  // Filter workflows by selected tags
  const filteredWorkflows = allWorkflows.filter(workflow => {
    if (selectedTags.length === 0) return true;
    if (!workflow.tags || workflow.tags.length === 0) return false;
    return selectedTags.some(selectedTag =>
      workflow.tags.some(tag => tag.name === selectedTag)
    );
  });

  // Save view state when it changes
  useEffect(() => { ViewStateManager.setWorkflowView({ isTableView }) }, [isTableView]);


  // Load workflows on mount
  useEffect(() => {
    dispatch(getAllWorkflows({
      status: selectedStatus === 'all' ? '' : selectedStatus,
      type: selectedType === 'all' ? '' : selectedType,
      search: searchText
    }));
    // eslint-disable-next-line
  }, [selectedStatus, selectedType]);

  // Load workspace analytics
  useEffect(() => {
    dispatch(getWorkspaceAnalytics({ days: 7 }));
  }, [dispatch]);


  // Handle search with debounce
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      dispatch(getAllWorkflows({
        status: selectedStatus === 'all' ? '' : selectedStatus,
        type: selectedType === 'all' ? '' : selectedType,
        search: searchText
      }));
    }, 500);

    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line
  }, [searchText]);

  const handleCreateWorkflow = () => {
    setIsWorkflowOpen(true); // sets state true
    dispatch(setWorkflowBuilderModal(true));
    history.push(getWorkspacePath('/agent/workflows/edit', currentWorkspace?._id));
  };

  const handleImportClick = () => {
    fileInputRef.current?.click();
    setCreateMenuAnchor(null); // Close dropdown menu
  };

  const handleFileSelect = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    // Reset file input value to allow re-importing the same file
    event.target.value = '';

    // Validate file type
    if (!file.name.endsWith('.json')) {
      EventBus.publish('error', 'Please select a valid JSON file');
      return;
    }

    try {
      setImportLoading(true);

      // Read file content
      const text = await file.text();

      // Parse JSON
      const workflowData = JSON.parse(text);

      // Basic validation
      if (!workflowData.name) {
        EventBus.publish('error', 'Invalid workflow file: missing name field');
        setImportLoading(false);
        return;
      }

      if (!workflowData.nodes || !Array.isArray(workflowData.nodes)) {
        EventBus.publish('error', 'Invalid workflow file: missing or invalid nodes array');
        setImportLoading(false);
        return;
      }

      // Import workflow using Redux action (creates new workflow on server)
      dispatch(importWorkflow({
        workflowData,
        successCallback: (response) => {
          setImportLoading(false);
          EventBus.publish('success', `Workflow "${workflowData.name}" imported successfully`);

          // Redirect to the newly imported workflow
          if (response?.workflow?._id) {
            history.push(getWorkspacePath(`/agent/workflows/${response.workflow._id}`, currentWorkspace?._id));
          }
        },
        failCallback: (error) => {
          setImportLoading(false);
          EventBus.publish('error', error?.message || 'Failed to import workflow');
        }
      }));
    } catch (error) {
      setImportLoading(false);
      if (error instanceof SyntaxError) {
        EventBus.publish('error', 'Invalid JSON file: ' + error.message);
      } else {
        EventBus.publish('error', 'Failed to read file: ' + error.message);
      }
    }
  };


  // when you want to close
  const handleCloseWorkflow = () => {
    setIsWorkflowOpen(false); // state false => class removed
    dispatch(setWorkflowBuilderModal(false));
  };

  const handleEditWorkflow = (workflow) => {
    if (!workflow || !workflow._id) {
      console.error("Invalid workflow row:", workflow);
      return;
    }
    console.log("Editing workflow:", workflow); // check correct row aa raha hai ya nahi
    setIsWorkflowOpen(true); // Set state to true
    dispatch(setSelectedWorkflow(workflow)); // redux state update
  };

  const handleExecuteWorkflow = (workflow) => {
    if (!workflow || !workflow._id) {
      console.error('Cannot execute workflow: workflow is undefined or missing _id');
      EventBus.publish('error', 'Please select a workflow to execute');
      return;
    }

    EventBus.publish('success', 'Workflow execution started successfully');

    // Directly execute the workflow without modal
    dispatch(executeWorkflow({
      id: workflow._id,
      input: {},  // Empty input for direct execution
      successCallback: (result) => {
        // Optionally navigate to execution details
        if (result.executionId) history.push(`/agent/workflows/executions/${result.executionId}`);
      },
      failCallback: (error) => {
        EventBus.publish('error', error?.response?.data?.message || 'Failed to execute workflow');
      }
    }));
  };

  // open modal and set default name
  const openCloneModal = (workflow) => {
    setMenuWorkflow(workflow);
    setNewName(`${workflow.name} (Copy)`); // prefill
    setCloneModal(true);
  };

  // handle cloning
  const handleCloneWorkflow = () => {
    if (newName && menuWorkflow) {
      dispatch(cloneWorkflow({ id: menuWorkflow._id, name: newName }));
      setCloneModal(false);
      setNewName("");
      setMenuWorkflow(null);
    }
  };

  const handleDeleteClick = (workflow) => {
    if (!workflow || !workflow._id) {
      console.error('Cannot delete workflow: workflow is undefined');
      return;
    }
    setWorkflowToDelete(workflow);
    setDeleteModal(true);
  };

  const confirmDelete = () => {
    if (workflowToDelete) {
      // Single workflow deletion
      dispatch(deleteWorkflow(workflowToDelete._id));
      setDeleteModal(false);
      setWorkflowToDelete(null);
      // Clear selection if the deleted workflow was selected
      setSelectedRows(prev => prev.filter(w => w._id !== workflowToDelete._id));
      setToggleCleared(!toggleCleared);
    } else if (workflowsToDelete.length > 0) {
      // Bulk deletion
      const workflowIds = workflowsToDelete.map(w => w._id);
      dispatch(batchDeleteWorkflows(workflowIds));
      setDeleteModal(false);
      setWorkflowsToDelete([]);
      // Clear selection after deletion
      setSelectedRows([]);
      setToggleCleared(!toggleCleared);
    }
  };

  const handleBulkDelete = () => {
    if (selectedRows.length === 0) return;

    if (selectedRows.length === 1) {
      // Single workflow deletion
      setWorkflowToDelete(selectedRows[0]);
      setWorkflowsToDelete([]);
    } else {
      // Multiple workflows deletion
      setWorkflowToDelete(null);
      setWorkflowsToDelete(selectedRows);
    }
    setDeleteModal(true);
  };

  const handleMenuOpen = (event, workflow) => {
    setAnchorEl(event.currentTarget);
    setMenuWorkflow(workflow);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuWorkflow(null);
  };

  const handleStatusChange = (workflowId, newStatus) => {
    console.log('handleStatusChange called:', { workflowId, newStatus });

    dispatch(updateWorkflow(
      workflowId,
      { status: newStatus },
      (updatedWorkflow) => {
        console.log('Status change successful:', updatedWorkflow);
        // No need to refresh - Redux will update the state automatically
      },
      (error) => {
        console.error('Status change failed:', error);
      }
    ));
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'active':
        return <ActiveIcon color="success" fontSize="small" />;
      case 'paused':
        return <PausedIcon color="warning" fontSize="small" />;
      case 'inactive':
        return <ActiveIcon color="action" fontSize="small" />;
      case 'archived':
        return <ArchiveIcon color="disabled" fontSize="small" />;
      default:
        return null;
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case 'custom':
        return 'primary';
      case 'system':
        return 'default';
      default:
        return 'default';
    }
  }

  const columns = [
    {
      name: 'Name',
      selector: row => row.name,
      sortable: false,
      cell: row => (
        <Box className="workflow-icon" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {getStatusIcon(row.status)}
          <Link
            to={`/agent/workflows/${row._id}/edit`}
            style={{ textDecoration: 'none', color: 'inherit' }}
            onClick={(e) => {
              e.stopPropagation(); // prevent row click firing twice
              handleEditWorkflow(row);
            }}
          >
            <Typography
              variant="body2"
              sx={{
                cursor: 'pointer',
                '&:hover': { textDecoration: 'underline' }
              }}

            >
              {row.name}
            </Typography>
          </Link>
        </Box>
      ),
    },
    {
      name: 'Type',
      selector: row => row.type,
      sortable: false,
      cell: row => (
        <p className={getTypeColor(row.type)}>{row.type}</p>
        // <Chip
        //   label={row.type}
        //   size="small"
        //   color=
        //   variant="outlined"
        // />
      ),
    },
    {
      name: 'Tags',
      selector: row => row.tags,
      sortable: false,
      cell: row => (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1px', margin: '5px 0' }}>
          {row.tags && row.tags.length > 0 ? (
            row.tags.slice(0, 3).map((tag, index) => (
              <Chip
                key={index}
                label={tag.name}
                size="small"
                sx={{
                  backgroundColor: tag.color || '#08245dff',
                  // color: getContrastTextColor(tag.color),
                  color: 'white',
                  // fontSize: '11px',
                  // height: '20px',
                  '& .MuiChip-label': {
                    px: 1,
                  }
                }}
              />
            ))
          ) : (
            <Typography variant="caption" color="textSecondary">-</Typography>
          )}
          {row.tags && row.tags.length > 3 && (
            <Chip
              label={`+${row.tags.length - 3}`}
              size="small"
              variant="outlined"
              sx={{
                // fontSize: '11px',
                // height: '20px',
                '& .MuiChip-label': {
                  px: 1,
                }
              }}
            />
          )}
        </div>
      ),
    },
    {
      name: 'Status',
      selector: row => row.status,
      sortable: false,
      cell: row => (
        <Chip
          label={row.status}
          size="small"
          color={row.status === 'active' ? 'success' : 'default'}
        />
      ),
    },
    {
      name: 'Executions',
      selector: row => row.metrics?.totalExecutions || 0,
      sortable: false,
      cell: row => (
        <Typography variant="body2">{row.metrics?.totalExecutions || 0} runs</Typography>
      ),
    },
    {
      name: 'Nodes',
      selector: row => row.nodes?.length || 0,
      sortable: false,
      cell: row => renderDynamicNodeIcons(row),
    },
    // {
    //   name: 'Created',
    //   selector: row => row.createdAt,
    //   sortable: false,
    //   cell: row => (
    //     <Box>
    //       <Typography variant="caption">
    //         {moment(row.createdAt).format('MMM DD, YYYY')}
    //       </Typography>
    //     </Box>
    //   ),
    //   width: '150px'
    // },
    {
      name: 'Last Run',
      selector: row => row.metrics?.lastExecutionDate || row.updatedAt,
      sortable: false,
      cell: row => (
        <Box>
          <Typography variant="caption">
            {row.metrics?.lastExecutionDate
              ? moment(row.metrics.lastExecutionDate).fromNow()
              : 'Never'
            }
          </Typography>
        </Box>
      ),
    },
    {
      name: 'Owner',
      selector: row => row.createdBy?.firstName || row.createdBy?.email || 'Unknown',
      sortable: false,
      cell: row => {
        const ownerName = row.createdBy ?
          `${row.createdBy.firstName || ''} ${row.createdBy.lastName || ''}`.trim() || row.createdBy.email :
          'Unknown';
        const initial = ownerName ? ownerName.charAt(0).toUpperCase() : '?';

        return (
          <div className='owner-box' title={ownerName}>
            <span className='text-box'>{initial}</span>
          </div>
        );
      },
    },
    {
      name: 'Actions',
      cell: row => (
        <div className='action-box workflwo-action'>
          <label>
            {/* {row.status === "active" ? "Active" : "Inactive"} */}
            <Switch
              checked={row.status === "active"}
              onChange={(e) =>
                handleStatusChange(row._id, e.target.checked ? "active" : "inactive")
              }
            />
          </label>
          {/* <button className='action-btn-workflow' color='primary' onClick={() => handleExecuteWorkflow(row)} disabled={row.status !== 'active'} title="Execute Workflow"><PlayIcon fontSize="small" /></button>
          <button className='action-btn-workflow' color='info' onClick={() => handleEditWorkflow(row)} title="Edit Workflow"><EditIcon fontSize="small" /></button>
          <button className='action-btn-workflow' color='secondary' onClick={() => history.push(`/agent/workflows/${row._id}/schedule`)} title="Schedule Workflow"> <ScheduleIcon fontSize="small" /></button> */}
          <button className='action-btn-workflow' color='dropdown' onClick={(e) => handleMenuOpen(e, row)} title="More Actions"> <MoreIcon fontSize="small" /></button>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem
              onClick={() => {
                if (menuWorkflow) {
                  handleExecuteWorkflow(menuWorkflow);
                  handleMenuClose();
                }
              }}
              disabled={!menuWorkflow || menuWorkflow.status !== 'active'}
            >
              <ListItemIcon>
                <PlayIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Execute Workflow</ListItemText>
            </MenuItem>

            <MenuItem onClick={() => { history.push(`/agent/workflows/${menuWorkflow._id}/edit`); handleEditWorkflow(menuWorkflow); }}>
              <ListItemIcon>
                <EditIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Edit Workflow</ListItemText>
            </MenuItem>

            {/* <MenuItem
              onClick={() => {
                setScheduleDialog(true);
                handleMenuClose();
              }}
              disabled={!menuWorkflow}
            >
              <ListItemIcon>
                <ScheduleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Schedule Workflow</ListItemText>
            </MenuItem> */}

            {/* <MenuItem onClick={() => {
              setCloneModal(true);
              handleMenuClose();
            }}>
              <ListItemIcon>
                <CopyIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Clone</ListItemText>
            </MenuItem> */}
            <MenuItem
              onClick={() => {
                if (menuWorkflow && menuWorkflow._id) {
                  handleDeleteClick(menuWorkflow);
                  handleMenuClose();
                }
              }}
              disabled={!menuWorkflow}
            >
              <ListItemIcon>
                <DeleteIcon fontSize="small" color="error" />
              </ListItemIcon>
              <ListItemText>Delete</ListItemText>
            </MenuItem>
          </Menu>
        </div>
      ),
    }
  ]

  const OwnerBox = ({ createdBy }) => {
    const ownerName = createdBy
      ? `${createdBy.firstName || ''} ${createdBy.lastName || ''}`.trim() || createdBy.email
      : 'Unknown';

    const initial = ownerName ? ownerName.charAt(0).toUpperCase() : '?';

    return (
      <div className="owner-box" title={ownerName}>
        <span className="text-box">{initial}</span>
      </div>
    )
  }


  const WorkflowCard = ({ workflow }) => {
    const isSelected = selectedRows.some(w => w._id === workflow._id);

    // ✅ Handle checkbox click for each card
    const handleCheckboxClick = (workflow, e) => {
      e.stopPropagation();

      setSelectedRows(prev => {
        const exists = prev.some(w => w._id === workflow._id);
        return exists
          ? prev.filter(w => w._id !== workflow._id) // unselect if already selected
          : [...prev, workflow]; // select this one
      });
    };


    return (
      <>
        <div className="agent-card style-workflow" onClick={() => { history.push(`/agent/workflows/${workflow._id}/edit`); handleEditWorkflow(workflow); }}>
          <div className="agent-header">
            <div className={`checkbox-right-area`}>
              <Checkbox
                checked={isSelected}
                onClick={(e) => handleCheckboxClick(workflow, e)}
              />
            </div>
            <div className='img-box'>
              {/* {getStatusIcon(workflow.status)} */}
              <OwnerBox createdBy={workflow.createdBy} />
            </div>
            <div className="agent-info">
              <h4 className="agent-name">{workflow.name}</h4>
              <div className="agent-detail">{workflow.description || 'No description'}</div>
            </div>

            <div className='tags-area'>
              <div className='tags-box'>
                <Chip label={workflow.type} size="small" color={getTypeColor(workflow.type)} variant="outlined" />
              </div>
              <div className='status'>
                <Chip label={workflow.status} size="small" color={workflow.status === 'active' ? 'success' : 'default'} />
              </div>
            </div>

            {/* Display workflow tags */}
            {workflow.tags && workflow.tags.length > 0 && (
              <div className='tags-area' style={{ marginLeft: '8px' }}>
                {workflow.tags.slice(0, 2).map((tag, index) => (
                  <Chip
                    key={index}
                    label={tag.name}
                    size="small"
                    sx={{
                      backgroundColor: tag.color || '#6B7280',
                      color: getContrastTextColor(tag.color),
                      // fontSize: '11px',
                      // height: '20px',
                      '& .MuiChip-label': {
                        px: 1,
                      }
                    }}
                  />
                ))}
                {workflow.tags.length > 2 && (
                  <Chip
                    label={`+${workflow.tags.length - 2}`}
                    size="small"
                    variant="outlined"
                    sx={{
                      // fontSize: '11px',
                      // height: '20px',
                      '& .MuiChip-label': {
                        px: 1,
                      }
                    }}
                  />
                )}
              </div>
            )}

          </div>
          <div className={`respond-box-area`}>
            <div className={`respond-box`}>
              <div className='nodes-area'>
                <h5>Nodes </h5>
                {renderDynamicNodeIcons(workflow)}
              </div>
            </div>
            <div className={`respond-box`}>
              <div className="icon">
                <svg width="12" height="12" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="PlayArrowIcon"><path d="M8 5v14l11-7z"></path></svg>
              </div>
              <div className='text-bx'>
                <p>{workflow.metrics?.totalExecutions || 0}  <span>executions</span></p>
              </div>
            </div>

            <div className={`respond-box`}>
              <div className="icon">
                <svg focusable="false" width="12" height="12" aria-hidden="true" viewBox="0 0 24 24" data-testid="ScheduleIcon"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"></path><path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"></path></svg>
              </div>
              <div className='text-bx'>
                <p><span>Updated </span> {moment(workflow.updatedAt).fromNow()}</p>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  };


  // table stats
  const isPaginated = allWorkflows.length > 100;
  const headerScrollHeight = isPaginated ? 'calc(100vh - 301px)' : 'calc(100vh - 301px)';
  const responsiveClass = isPaginated ? 'datatable--paginated' : 'datatable--fullheight contact-table';

  return (
    <>
      <div className='content'>
        <div className='main-container'>
          <div className='bottom-content-area'>
            <div className='tabs-content'>
              <div className='content'>
                <div className='allemails-area'>
                  <div className='page-title-area'>
                    <div className='title-left' style={{ width: '50%' }}>
                      <TitleRoute
                        title="Workflows"
                      />
                      <p className='records-title'>Automate your sales processes with intelligent workflows</p>
                    </div>
                    <div className='right-btn-area'>
                      {/* Hidden file input for importing workflows */}
                      <input
                        type="file"
                        ref={fileInputRef}
                        accept="application/json,.json"
                        style={{ display: 'none' }}
                        onChange={handleFileSelect}
                      />
                      <button
                        className='btn-style-border'
                        onClick={() => history.push(getWorkspacePath('/agent/workflows/templates'))}
                      >
                        <svg width="13" height="13" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '5px', verticalAlign: 'middle' }}>
                          <path d="M15 2H5C3.89543 2 3 2.89543 3 4V16C3 17.1046 3.89543 18 5 18H15C16.1046 18 17 17.1046 17 16V4C17 2.89543 16.1046 2 15 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M7 6H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M7 10H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M7 14H10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        Templates
                      </button>
                      <div style={{
                        display: 'inline-flex',
                        position: 'relative',
                        borderRadius: '6px',
                        overflow: 'hidden'
                      }}>
                        <button
                          className='btn-style-new'
                          onClick={handleCreateWorkflow}
                          style={{
                            borderTopRightRadius: '0',
                            borderBottomRightRadius: '0',
                            borderRight: 'none',
                            padding: '8px 16px',
                            fontSize: '14px',
                            lineHeight: '1.5'
                          }}
                        >+ Create Workflow</button>
                        <button
                          className='btn-style-new'
                          onClick={(e) => setCreateMenuAnchor(e.currentTarget)}
                          style={{
                            borderTopLeftRadius: '0',
                            borderBottomLeftRadius: '0',
                            padding: '8px 10px',
                            minWidth: 'auto',
                            borderLeft: '1px solid rgba(255, 255, 255, 0.2)',
                            marginLeft: '0'
                          }}
                        >
                          <ArrowDropDownIcon style={{ fontSize: '16px' }} />
                        </button>
                        <Menu
                          anchorEl={createMenuAnchor}
                          open={Boolean(createMenuAnchor)}
                          onClose={() => setCreateMenuAnchor(null)}
                        >
                          <MenuItem onClick={handleImportClick} disabled={importLoading}>
                            <ListItemIcon>
                              <UploadIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>
                              {importLoading ? 'Importing...' : 'Import Workflow'}
                            </ListItemText>
                          </MenuItem>
                        </Menu>
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-12'>
                      <div className='counter-sections counter-workflow'>
                        <div className='counter-box counter-up'>
                          <div className='counter-start' >
                            <div className='left-text-area'>
                              <h5>Production executions</h5>
                              <p>Last 7 days</p>
                              <div className='status-text'>
                                <div className='CountUp-box'>
                                  <span>{workspaceAnalytics?.summary?.totalExecutions || 0}</span>
                                </div>
                                <span className='icon-text'>
                                  <svg width='15' height='9' viewBox='0 0 15 9' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                    <path d='M10.5 0L12.2175 1.7175L8.5575 5.3775L5.5575 2.3775L0 7.9425L1.0575 9L5.5575 4.5L8.5575 7.5L13.2825 2.7825L15 4.5V0H10.5Z' fill='#94C8FB' />
                                  </svg>
                                  {/* We'll calculate trend later */}
                                  --
                                </span>
                              </div>
                            </div>
                            <div className='right-icon'>
                              <span className='icon'>
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <circle opacity="0.1" cx="20" cy="20" r="20" fill="#6DA92F" />
                                  <path d="M18.8273 30C18.6917 29.9405 18.5477 29.8957 18.4225 29.8195C18.0374 29.5873 17.8376 29.2352 17.8178 28.7891C17.7813 27.9716 17.3122 27.429 16.5109 27.321C16.0726 27.262 15.6913 27.4117 15.3725 27.7164C15.0078 28.0649 14.5769 28.1902 14.099 28.0342C13.8976 27.9684 13.704 27.8328 13.547 27.6862C13.1333 27.3001 12.7414 26.8905 12.3418 26.4899C11.7637 25.9097 11.7361 25.2247 12.2954 24.6216C13.0555 23.802 12.6267 22.529 11.6756 22.2504C11.5342 22.2092 11.3824 22.1919 11.2347 22.1867C10.5267 22.1606 10.0035 21.6264 10.0014 20.9158C9.99981 20.3038 9.99929 19.6924 10.0014 19.0804C10.0035 18.3719 10.5288 17.8351 11.2399 17.8178C11.8618 17.8027 12.3126 17.5137 12.5588 16.9497C12.8082 16.3784 12.7101 15.8468 12.2896 15.3772C11.7434 14.7679 11.7653 14.0891 12.3455 13.5074C12.7315 13.1203 13.1176 12.7337 13.5047 12.3476C14.0927 11.7617 14.7673 11.7445 15.3897 12.3012C15.8149 12.682 16.3022 12.789 16.838 12.6038C17.3722 12.4191 17.6978 12.0361 17.7985 11.4758C17.8272 11.3167 17.8178 11.1508 17.8491 10.9922C17.9654 10.4073 18.46 10.004 19.0569 10.002C19.6814 9.99935 20.3064 9.99935 20.9309 10.002C21.6185 10.0046 22.1554 10.5268 22.1814 11.2139C22.2127 12.0294 22.6901 12.5719 23.491 12.6779C23.9381 12.7368 24.3205 12.5782 24.6445 12.2694C25.0055 11.925 25.4349 11.8134 25.9034 11.9673C26.1048 12.0335 26.2968 12.1713 26.4543 12.3179C26.854 12.6904 27.2176 13.102 27.6214 13.4693C28.247 14.038 28.2078 14.868 27.6825 15.4211C26.9687 16.1729 27.3235 17.4344 28.3085 17.7453C28.4426 17.7876 28.5876 17.809 28.729 17.8137C29.3447 17.8351 29.7819 18.1674 29.9619 18.7622C29.9692 18.7856 29.9859 18.8065 29.9979 18.8289C29.9979 19.6099 29.9979 20.3915 29.9979 21.1725C29.9895 21.1824 29.9759 21.1913 29.9739 21.2022C29.8549 21.7641 29.3358 22.1852 28.6701 22.1982C28.4254 22.2029 28.1536 22.3036 27.9464 22.4398C27.2004 22.9297 27.1002 23.9397 27.7033 24.6159C28.2204 25.1955 28.235 25.8899 27.7263 26.4168C27.2969 26.8619 26.8555 27.2949 26.4157 27.7295C26.2112 27.9314 25.967 28.0571 25.6764 28.0874C25.2679 28.1302 24.9231 28.0008 24.6283 27.718C24.3101 27.4133 23.9292 27.2636 23.4899 27.3231C22.6865 27.4321 22.2143 27.9705 22.1825 28.7891C22.1616 29.3244 21.822 29.7762 21.3138 29.9452C21.2658 29.9614 21.2189 29.9817 21.1714 30C20.3893 30 19.6083 30 18.8273 30ZM13.1771 14.4752C13.9539 15.3444 14.1767 16.3278 13.7291 17.4057C13.2793 18.4883 12.4175 19.0251 11.2613 19.0835C11.2613 19.7065 11.2613 20.3091 11.2613 20.9184C12.4305 20.9795 13.2825 21.5194 13.7296 22.5958C14.1793 23.6788 13.9503 24.6665 13.1943 25.5075C13.6325 25.9473 14.0624 26.3782 14.4918 26.8081C15.3443 26.0454 16.3272 25.8226 17.4051 26.2692C18.4892 26.7184 19.0235 27.5818 19.0824 28.739C19.7043 28.739 20.3069 28.739 20.9168 28.739C20.9778 27.5703 21.5168 26.7184 22.5931 26.2707C23.6767 25.82 24.6638 26.049 25.5074 26.8076C25.9457 26.3699 26.3766 25.9395 26.807 25.5096C26.0448 24.6565 25.821 23.6741 26.2681 22.5958C26.7178 21.5116 27.5792 20.9758 28.7369 20.9163C28.7369 20.2955 28.7369 19.6924 28.7369 19.0809C27.5687 19.022 26.7168 18.482 26.2691 17.4062C25.8184 16.3226 26.0463 15.335 26.806 14.4903C26.3693 14.0515 25.9394 13.6201 25.51 13.1886C24.6554 13.9535 23.6725 14.1773 22.5941 13.7302C21.511 13.281 20.9737 12.4196 20.9147 11.2614C20.2933 11.2614 19.6908 11.2614 19.0809 11.2614C19.0188 12.4295 18.4809 13.2831 17.4041 13.7296C16.321 14.1788 15.3334 13.9519 14.4751 13.1777C14.0395 13.6128 13.6122 14.0406 13.1771 14.4752Z" fill="#6DA92F" />
                                  <path d="M25.2383 19.9981C25.2404 22.8978 22.8859 25.2502 19.9908 25.2413C17.0927 25.232 14.7606 22.8973 14.759 20.0022C14.7575 17.101 17.1104 14.7506 20.006 14.7595C22.9052 14.7683 25.2362 17.1025 25.2383 19.9981ZM19.994 23.9871C22.1925 23.9887 23.983 22.2039 23.9851 20.0095C23.9872 17.8079 22.2071 16.0168 20.0133 16.0132C17.8111 16.0095 16.0164 17.7891 16.0127 19.9808C16.0091 22.194 17.7897 23.9861 19.994 23.9871Z" fill="#6DA92F" />
                                  <path d="M18.8709 20.5724C19.425 20.0997 19.9149 19.6818 20.4042 19.2645C20.8299 18.9013 21.2546 18.5361 21.6824 18.1756C21.9725 17.9315 22.3628 17.9487 22.5908 18.2095C22.8266 18.4793 22.7927 18.8732 22.4963 19.1278C21.4492 20.0262 20.4001 20.922 19.3477 21.8146C19.0279 22.0859 18.7128 22.0677 18.4086 21.776C18.0987 21.4786 17.7904 21.1792 17.4836 20.8781C17.1951 20.5954 17.1758 20.202 17.4336 19.9422C17.6845 19.6897 18.0758 19.6975 18.3544 19.9792C18.537 20.1639 18.6972 20.371 18.8709 20.5724Z" fill="#6DA92F" />
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className='counter-box counter-danger'>
                          <div className='counter-start' >
                            <div className='left-text-area'>
                              <h5>Failed production executions</h5>
                              <p>Last 7 days</p>
                              <div className='status-text'>
                                <div className='CountUp-box'>
                                  <span>{workspaceAnalytics?.summary?.failedExecutions || 0}</span>
                                </div>
                                <span className='icon-text'>
                                  <svg width='15' height='9' viewBox='0 0 15 9' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                    <path d='M10.5 0L12.2175 1.7175L8.5575 5.3775L5.5575 2.3775L0 7.9425L1.0575 9L5.5575 4.5L8.5575 7.5L13.2825 2.7825L15 4.5V0H10.5Z' fill='#94C8FB' />
                                  </svg>
                                  {/* We'll calculate trend later */}
                                  --
                                </span>
                              </div>
                            </div>
                            <div className='right-icon'>
                              <span className='icon'>
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <circle opacity="0.1" cx="20" cy="20" r="20" fill="#FF8B00" />
                                  <path d="M18.8273 30C18.6917 29.9405 18.5477 29.8957 18.4225 29.8195C18.0374 29.5873 17.8376 29.2352 17.8178 28.7891C17.7813 27.9716 17.3122 27.429 16.5109 27.321C16.0726 27.262 15.6913 27.4117 15.3725 27.7164C15.0078 28.0649 14.5769 28.1902 14.099 28.0342C13.8976 27.9684 13.704 27.8328 13.547 27.6862C13.1333 27.3001 12.7414 26.8905 12.3418 26.4899C11.7637 25.9097 11.7361 25.2247 12.2954 24.6216C13.0555 23.802 12.6267 22.529 11.6756 22.2504C11.5342 22.2092 11.3824 22.1919 11.2347 22.1867C10.5267 22.1606 10.0035 21.6264 10.0014 20.9158C9.99981 20.3038 9.99929 19.6924 10.0014 19.0804C10.0035 18.3719 10.5288 17.8351 11.2399 17.8178C11.8618 17.8027 12.3126 17.5137 12.5588 16.9497C12.8082 16.3784 12.7101 15.8468 12.2896 15.3772C11.7434 14.7679 11.7653 14.0891 12.3455 13.5074C12.7315 13.1203 13.1176 12.7337 13.5047 12.3476C14.0927 11.7617 14.7673 11.7445 15.3897 12.3012C15.8149 12.682 16.3022 12.789 16.838 12.6038C17.3722 12.4191 17.6978 12.0361 17.7985 11.4758C17.8272 11.3167 17.8178 11.1508 17.8491 10.9922C17.9654 10.4073 18.46 10.004 19.0569 10.002C19.6814 9.99935 20.3064 9.99935 20.9309 10.002C21.6185 10.0046 22.1554 10.5268 22.1814 11.2139C22.2127 12.0294 22.6901 12.5719 23.491 12.6779C23.9381 12.7368 24.3205 12.5782 24.6445 12.2694C25.0055 11.925 25.4349 11.8134 25.9034 11.9673C26.1048 12.0335 26.2968 12.1713 26.4543 12.3179C26.854 12.6904 27.2176 13.102 27.6214 13.4693C28.247 14.038 28.2078 14.868 27.6825 15.4211C26.9687 16.1729 27.3235 17.4344 28.3085 17.7453C28.4426 17.7876 28.5876 17.809 28.729 17.8137C29.3447 17.8351 29.7819 18.1674 29.9619 18.7622C29.9692 18.7856 29.9859 18.8065 29.9979 18.8289C29.9979 19.6099 29.9979 20.3915 29.9979 21.1725C29.9895 21.1824 29.9759 21.1913 29.9739 21.2022C29.8549 21.7641 29.3358 22.1852 28.6701 22.1982C28.4254 22.2029 28.1536 22.3036 27.9464 22.4398C27.2004 22.9297 27.1002 23.9397 27.7033 24.6159C28.2204 25.1955 28.235 25.8899 27.7263 26.4168C27.2969 26.8619 26.8555 27.2949 26.4157 27.7295C26.2112 27.9314 25.967 28.0571 25.6764 28.0874C25.2679 28.1302 24.9231 28.0008 24.6283 27.718C24.3101 27.4133 23.9292 27.2636 23.4899 27.3231C22.6865 27.4321 22.2143 27.9705 22.1825 28.7891C22.1616 29.3244 21.822 29.7762 21.3138 29.9452C21.2658 29.9614 21.2189 29.9817 21.1714 30C20.3893 30 19.6083 30 18.8273 30ZM13.1771 14.4752C13.9539 15.3444 14.1767 16.3278 13.7291 17.4057C13.2793 18.4883 12.4175 19.0251 11.2613 19.0835C11.2613 19.7065 11.2613 20.3091 11.2613 20.9184C12.4305 20.9795 13.2825 21.5194 13.7296 22.5958C14.1793 23.6788 13.9503 24.6665 13.1943 25.5075C13.6325 25.9473 14.0624 26.3782 14.4918 26.8081C15.3443 26.0454 16.3272 25.8226 17.4051 26.2692C18.4892 26.7184 19.0235 27.5818 19.0824 28.739C19.7043 28.739 20.3069 28.739 20.9168 28.739C20.9778 27.5703 21.5168 26.7184 22.5931 26.2707C23.6767 25.82 24.6638 26.049 25.5074 26.8076C25.9457 26.3699 26.3766 25.9395 26.807 25.5096C26.0448 24.6565 25.821 23.6741 26.2681 22.5958C26.7178 21.5116 27.5792 20.9758 28.7369 20.9163C28.7369 20.2955 28.7369 19.6924 28.7369 19.0809C27.5687 19.022 26.7168 18.482 26.2691 17.4062C25.8184 16.3226 26.0463 15.335 26.806 14.4903C26.3693 14.0515 25.9394 13.6201 25.51 13.1886C24.6554 13.9535 23.6725 14.1773 22.5941 13.7302C21.511 13.281 20.9737 12.4196 20.9147 11.2614C20.2933 11.2614 19.6908 11.2614 19.0809 11.2614C19.0188 12.4295 18.4809 13.2831 17.4041 13.7296C16.321 14.1788 15.3334 13.9519 14.4751 13.1777C14.0395 13.6128 13.6122 14.0406 13.1771 14.4752Z" fill="#FF8B00" />
                                  <path d="M26 19.9977C26.0024 23.319 23.3056 26.0134 19.9897 26.0032C16.6702 25.9925 13.9991 23.3184 13.9973 20.0025C13.9955 16.6794 16.6905 13.9874 20.007 13.9976C23.3277 14.0077 25.9976 16.6812 26 19.9977ZM19.9933 24.5667C22.5114 24.5685 24.5622 22.5242 24.5646 20.0109C24.567 17.4891 22.5281 15.4377 20.0154 15.4335C17.4931 15.4293 15.4374 17.4676 15.4333 19.978C15.4291 22.5129 17.4686 24.5655 19.9933 24.5667Z" fill="#FF8B00" />
                                  <path d="M19.9994 23.0097C19.9625 23.0097 19.9193 23.0035 19.8762 22.9974C19.8392 22.9912 19.8022 22.9789 19.7652 22.9604C19.7282 22.9481 19.6912 22.9296 19.6543 22.9049C19.6234 22.8803 19.5926 22.8556 19.5618 22.831C19.4509 22.7138 19.3831 22.5536 19.3831 22.3933C19.3831 22.2331 19.4509 22.0728 19.5618 21.9557C19.5926 21.931 19.6234 21.9064 19.6543 21.8817C19.6912 21.8571 19.7282 21.8386 19.7652 21.8263C19.8022 21.8078 19.8392 21.7954 19.8762 21.7893C19.9563 21.7708 20.0426 21.7708 20.1165 21.7893C20.1597 21.7954 20.1967 21.8078 20.2337 21.8263C20.2706 21.8386 20.3076 21.8571 20.3446 21.8817C20.3754 21.9064 20.4062 21.931 20.4371 21.9557C20.548 22.0728 20.6158 22.2331 20.6158 22.3933C20.6158 22.5536 20.548 22.7138 20.4371 22.831C20.4062 22.8556 20.3754 22.8803 20.3446 22.9049C20.3076 22.9296 20.2706 22.9481 20.2337 22.9604C20.1967 22.9789 20.1597 22.9912 20.1165 22.9974C20.0796 23.0035 20.0364 23.0097 19.9994 23.0097Z" fill="#FF8B00" />
                                  <path d="M19.9994 21.0065C19.7467 21.0065 19.5371 20.7969 19.5371 20.5442V17.4623C19.5371 17.2096 19.7467 17 19.9994 17C20.2521 17 20.4617 17.2096 20.4617 17.4623V20.5442C20.4617 20.7969 20.2521 21.0065 19.9994 21.0065Z" fill="#FF8B00" />
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className='counter-box counter-danger'>
                          <div className='counter-start' >
                            <div className='left-text-area'>
                              <h5>Failure rate</h5>
                              <p>Last 7 days</p>
                              <div className='status-text'>
                                <div className='CountUp-box'>
                                  <span>{workspaceAnalytics?.summary?.failureRate || 0}%</span>
                                </div>
                                <span className='icon-text'>
                                  <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.16667 7L9.5025 5.66417L6.65583 2.8175L4.3225 5.15083L0 0.8225L0.8225 0L4.3225 3.5L6.65583 1.16667L10.3308 4.83583L11.6667 3.5V7H8.16667Z" fill="#EA4335" />
                                  </svg>
                                  {/* We'll calculate trend later */}
                                  --
                                </span>
                              </div>
                            </div>
                            <div className='right-icon'>
                              <span className='icon'>
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <circle opacity="0.1" cx="20" cy="20" r="20" fill="#C73A63" />
                                  <path d="M20 22.2917C19.6583 22.2917 19.375 22.0083 19.375 21.6667V17.5C19.375 17.1583 19.6583 16.875 20 16.875C20.3417 16.875 20.625 17.1583 20.625 17.5V21.6667C20.625 22.0083 20.3417 22.2917 20 22.2917Z" fill="#C73A63" />
                                  <path d="M20.0001 25C19.9501 25 19.8917 24.9917 19.8334 24.9833C19.7834 24.975 19.7334 24.9583 19.6834 24.9333C19.6334 24.9167 19.5834 24.8917 19.5334 24.8583C19.4917 24.825 19.4501 24.7917 19.4084 24.7583C19.2584 24.6 19.1667 24.3833 19.1667 24.1667C19.1667 23.95 19.2584 23.7333 19.4084 23.575C19.4501 23.5417 19.4917 23.5083 19.5334 23.475C19.5834 23.4417 19.6334 23.4167 19.6834 23.4C19.7334 23.375 19.7834 23.3583 19.8334 23.35C19.9417 23.325 20.0584 23.325 20.1584 23.35C20.2167 23.3583 20.2667 23.375 20.3167 23.4C20.3667 23.4167 20.4167 23.4417 20.4667 23.475C20.5084 23.5083 20.5501 23.5417 20.5917 23.575C20.7417 23.7333 20.8334 23.95 20.8334 24.1667C20.8334 24.3833 20.7417 24.6 20.5917 24.7583C20.5501 24.7917 20.5084 24.825 20.4667 24.8583C20.4167 24.8917 20.3667 24.9167 20.3167 24.9333C20.2667 24.9583 20.2167 24.975 20.1584 24.9833C20.1084 24.9917 20.0501 25 20.0001 25Z" fill="#C73A63" />
                                  <path d="M25.05 28.4667H14.95C13.325 28.4667 12.0833 27.875 11.45 26.8083C10.825 25.7417 10.9083 24.3667 11.7 22.9417L16.75 13.8583C17.5833 12.3583 18.7333 11.5333 20 11.5333C21.2666 11.5333 22.4166 12.3583 23.25 13.8583L28.3 22.95C29.0916 24.375 29.1833 25.7417 28.55 26.8167C27.9166 27.875 26.675 28.4667 25.05 28.4667ZM20 12.7833C19.2166 12.7833 18.45 13.3833 17.8416 14.4667L12.8 23.5583C12.2333 24.575 12.1416 25.5083 12.5333 26.1833C12.925 26.8583 13.7916 27.225 14.9583 27.225H25.0583C26.225 27.225 27.0833 26.8583 27.4833 26.1833C27.8833 25.5083 27.7833 24.5833 27.2166 23.5583L22.1583 14.4667C21.55 13.3833 20.7833 12.7833 20 12.7833Z" fill="#C73A63" />
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className='counter-box counter-successfull'>
                          <div className='counter-start' >
                            <div className='left-text-area'>
                              <h5>Average run time</h5>
                              <p>Last 7 days</p>
                              <div className='status-text'>
                                <div className='CountUp-box'>
                                  <span>{workspaceAnalytics?.summary?.averageRuntime ? (workspaceAnalytics.summary.averageRuntime / 1000).toFixed(2) + 's' : '0s'}</span>
                                </div>
                                <span className='icon-text'>
                                  <svg width='15' height='9' viewBox='0 0 15 9' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                    <path d='M10.5 0L12.2175 1.7175L8.5575 5.3775L5.5575 2.3775L0 7.9425L1.0575 9L5.5575 4.5L8.5575 7.5L13.2825 2.7825L15 4.5V0H10.5Z' fill='#94C8FB' />
                                  </svg>
                                  {/* We'll calculate trend later */}
                                  --
                                </span>
                              </div>
                            </div>
                            <div className='right-icon'>
                              <span className='icon'>
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <circle opacity="0.1" cx="20" cy="20" r="20" fill="#18BFFF" />
                                  <path d="M20 21.4583C19.6583 21.4583 19.375 21.175 19.375 20.8333V16.6667C19.375 16.325 19.6583 16.0417 20 16.0417C20.3417 16.0417 20.625 16.325 20.625 16.6667V20.8333C20.625 21.175 20.3417 21.4583 20 21.4583Z" fill="#18BFFF" />
                                  <path d="M20 28.9583C15.6334 28.9583 12.0834 25.4083 12.0834 21.0417C12.0834 16.675 15.6334 13.125 20 13.125C24.3667 13.125 27.9167 16.675 27.9167 21.0417C27.9167 21.3833 27.6334 21.6667 27.2917 21.6667C26.95 21.6667 26.6667 21.3833 26.6667 21.0417C26.6667 17.3667 23.675 14.375 20 14.375C16.325 14.375 13.3334 17.3667 13.3334 21.0417C13.3334 24.7167 16.325 27.7083 20 27.7083C20.3417 27.7083 20.625 27.9917 20.625 28.3333C20.625 28.675 20.3417 28.9583 20 28.9583Z" fill="#18BFFF" />
                                  <path d="M22.5 12.2917H17.5C17.1583 12.2917 16.875 12.0083 16.875 11.6667C16.875 11.325 17.1583 11.0417 17.5 11.0417H22.5C22.8417 11.0417 23.125 11.325 23.125 11.6667C23.125 12.0083 22.8417 12.2917 22.5 12.2917Z" fill="#18BFFF" />
                                  <path d="M23.4584 28.35C23.1667 28.35 22.9001 28.2833 22.6584 28.1417C22.1084 27.825 21.7917 27.1833 21.7917 26.3833V24.4583C21.7917 23.6583 22.1084 23.0167 22.6584 22.7C23.2084 22.3833 23.9167 22.4333 24.6084 22.825L26.2751 23.7917C26.9667 24.1917 27.3667 24.7833 27.3667 25.4167C27.3667 26.05 26.9667 26.6417 26.2751 27.0417L24.6084 28.0083C24.2251 28.2333 23.8334 28.35 23.4584 28.35ZM23.4667 23.7333C23.4001 23.7333 23.3334 23.75 23.2834 23.775C23.1334 23.8583 23.0417 24.1167 23.0417 24.45V26.375C23.0417 26.7083 23.1334 26.9667 23.2834 27.05C23.4334 27.1333 23.7001 27.0917 23.9834 26.925L25.6501 25.9583C25.9417 25.7917 26.1167 25.5833 26.1167 25.4167C26.1167 25.25 25.9417 25.0417 25.6501 24.875L23.9834 23.9083C23.7917 23.7917 23.6084 23.7333 23.4667 23.7333Z" fill="#18BFFF" />
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className='workflow-table-box'>
                        <div className="table-container filters-table workflow-table">
                          {selectedRows.length > 0 ? (
                            <div className='header-table-filters advanced-table-filters style-filter-show'>
                              <div className='left-area'>
                                <p>{selectedRows.length} workflow{selectedRows.length > 1 ? 's' : ''} selected</p>
                                {/* <div className="filter-deals-owner">
                                  <button className='assing-btn' onClick={() => { handleCloneWorkflow(menuWorkflow); handleMenuClose(); }}>
                                    <i className='icon'>
                                      <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.125 1.71875H1.375C1.11612 1.71875 0.90625 1.92862 0.90625 2.1875V5.9375C0.90625 6.19638 1.11612 6.40625 1.375 6.40625H2V7.1875H1.375C0.684644 7.1875 0.125 6.62786 0.125 5.9375V2.1875C0.125 1.49714 0.684644 0.9375 1.375 0.9375H5.125C5.81536 0.9375 6.375 1.49714 6.375 2.1875V2.5H5.59375V2.1875C5.59375 1.92862 5.38388 1.71875 5.125 1.71875Z" fill="var(--primary-color)" />
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.625 4.375C2.625 3.68464 3.18464 3.125 3.875 3.125H7.625C8.31536 3.125 8.875 3.68464 8.875 4.375V8.125C8.875 8.81536 8.31536 9.375 7.625 9.375H3.875C3.18464 9.375 2.625 8.81536 2.625 8.125V4.375ZM3.875 3.90625H7.625C7.88388 3.90625 8.09375 4.11612 8.09375 4.375V8.125C8.09375 8.38388 7.88388 8.59375 7.625 8.59375H3.875C3.61612 8.59375 3.40625 8.38388 3.40625 8.125V4.375C3.40625 4.11612 3.61612 3.90625 3.875 3.90625Z" fill="var(--primary-color)" />
                                      </svg>
                                    </i>
                                    Clone
                                  </button>
                                </div> */}
                                <div className="filter-deals-owner">
                                  <button onClick={handleBulkDelete} className='assing-btn'>
                                    <i className='icon'>
                                      <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.69189 2.74089C8.16564 2.58964 6.63023 2.51172 5.09939 2.51172C4.19189 2.51172 3.28439 2.55755 2.37689 2.64922L1.44189 2.74089" stroke="#4B5563" stroke-width="0.6875" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M3.96289 2.27775L4.06372 1.67734C4.13706 1.24192 4.19206 0.916504 4.96664 0.916504H6.16747C6.94206 0.916504 7.00164 1.26025 7.07039 1.68192L7.17122 2.27775" stroke="#4B5563" stroke-width="0.6875" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M8.70641 4.18945L8.4085 8.80487C8.35808 9.52445 8.31683 10.0836 7.03808 10.0836H4.09558C2.81683 10.0836 2.77558 9.52445 2.72516 8.80487L2.42725 4.18945" stroke="#4B5563" stroke-width="0.6875" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M4.80176 7.5625H6.32801" stroke="#4B5563" stroke-width="0.6875" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M4.4209 5.729H6.71257" stroke="#4B5563" stroke-width="0.6875" stroke-linecap="round" stroke-linejoin="round" />
                                      </svg>
                                    </i>
                                    Delete
                                  </button>
                                </div>

                                {/* <div className="filter-deals-owner">
                                  <button className="assing-btn" onClick={() => handleExecuteWorkflow(selectedRows)} disabled={selectedRows.status !== 'active'}>
                                    <i className='icon'>
                                      <svg width="12" height="12" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="PlayArrowIcon"><path d="M8 5v14l11-7z"></path></svg>
                                    </i>
                                    Execute Workflow
                                  </button>
                                </div> */}
                                {/* <div className="filter-deals-owner">
                                  <button className="assing-btn" onClick={() => handleEditWorkflow(selectedRows)}>
                                    <i className='icon'>
                                      <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.14459 1.64981L2.38167 5.63273C2.23959 5.78398 2.10209 6.0819 2.07459 6.28815L1.90501 7.77315C1.84542 8.3094 2.23042 8.67606 2.76209 8.5844L4.23792 8.33232C4.44417 8.29565 4.73292 8.1444 4.87501 7.98856L8.63792 4.00565C9.28876 3.31815 9.58209 2.5344 8.56917 1.57648C7.56084 0.627731 6.79542 0.962314 6.14459 1.64981Z" stroke="var(--primary-color)" stroke-width="0.6875" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.5166 2.31445C5.71368 3.57945 6.74035 4.54654 8.01452 4.67487" stroke="var(--primary-color)" stroke-width="0.6875" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M1.44189 10.0835H9.69189" stroke="var(--primary-color)" stroke-width="0.6875" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                    </i>
                                    Edit Workflow
                                  </button>
                                </div> */}
                                {/* <div className="filter-deals-owner">
                                  <button className="assing-btn" onClick={() => history.push(`/agent/workflows/${selectedRows._id}/schedule`)}>
                                    <i className='icon'>
                                      <svg focusable="false" width="12" height="12" aria-hidden="true" viewBox="0 0 24 24" data-testid="ScheduleIcon"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"></path><path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"></path></svg>
                                    </i>
                                    Schedule Workflow
                                  </button>
                                </div> */}
                              </div>
                              <div className='right-side-filter'>
                                <button className='close' onClick={() => { setToggleCleared(prev => !prev); setSelectedRows([]); }}>
                                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <mask id="path-1-inside-1_1030_1913" fill="white">
                                      <path d="M8.21204 0.303865C8.6172 -0.100965 9.28744 -0.101115 9.69251 0.303865C10.0977 0.709019 10.0977 1.38016 9.69251 1.78531L6.47962 4.9982L9.69251 8.21109C10.0977 8.61625 10.0977 9.28738 9.69251 9.69254C9.48301 9.902 9.21762 10.0001 8.95227 10.0002C8.68695 10.0002 8.42155 9.9019 8.21204 9.69254L4.99817 6.47867L1.78528 9.69254C1.58981 9.90197 1.31035 10 1.04504 10.0002C0.779599 10.0002 0.513396 9.9021 0.303834 9.69254C-0.101246 9.28738 -0.101295 8.61622 0.303834 8.21109L3.51672 4.9982L0.303834 1.78531C-0.101299 1.38018 -0.101257 0.709025 0.303834 0.303865C0.708987 -0.101288 1.38013 -0.101288 1.78528 0.303865L4.99817 3.51676L8.21204 0.303865Z" />
                                    </mask>
                                    <path d="M8.21204 0.303865C8.6172 -0.100965 9.28744 -0.101115 9.69251 0.303865C10.0977 0.709019 10.0977 1.38016 9.69251 1.78531L6.47962 4.9982L9.69251 8.21109C10.0977 8.61625 10.0977 9.28738 9.69251 9.69254C9.48301 9.902 9.21762 10.0001 8.95227 10.0002C8.68695 10.0002 8.42155 9.9019 8.21204 9.69254L4.99817 6.47867L1.78528 9.69254C1.58981 9.90197 1.31035 10 1.04504 10.0002C0.779599 10.0002 0.513396 9.9021 0.303834 9.69254C-0.101246 9.28738 -0.101295 8.61622 0.303834 8.21109L3.51672 4.9982L0.303834 1.78531C-0.101299 1.38018 -0.101257 0.709025 0.303834 0.303865C0.708987 -0.101288 1.38013 -0.101288 1.78528 0.303865L4.99817 3.51676L8.21204 0.303865Z" fill="var(--primary-color)" />
                                    <path d="M8.21204 0.303865L7.94019 0.0318008L7.94012 0.0318703L8.21204 0.303865ZM9.69251 0.303865L9.96446 0.0319116L9.96443 0.0318845L9.69251 0.303865ZM6.47962 4.9982L6.20766 4.72625L5.93571 4.9982L6.20766 5.27015L6.47962 4.9982ZM9.69251 9.69254L9.96444 9.96451L9.96446 9.96449L9.69251 9.69254ZM8.95227 10.0002V10.3848H8.95235L8.95227 10.0002ZM8.21204 9.69254L7.94008 9.96449L7.94018 9.96459L8.21204 9.69254ZM4.99817 6.47867L5.27012 6.20672L4.99813 5.93472L4.72617 6.20676L4.99817 6.47867ZM1.78528 9.69254L1.51312 9.42046L1.50411 9.43012L1.78528 9.69254ZM1.04504 10.0002V10.3848H1.04522L1.04504 10.0002ZM0.303834 9.69254L0.0318532 9.96446L0.0318803 9.96449L0.303834 9.69254ZM0.303834 8.21109L0.575787 8.48305L0.303834 8.21109ZM3.51672 4.9982L3.78868 5.27015L4.06063 4.9982L3.78868 4.72625L3.51672 4.9982ZM0.303834 0.303865L0.0318803 0.0319116L0.0318571 0.0319349L0.303834 0.303865ZM4.99817 3.51676L4.72622 3.78871L4.99813 4.06062L5.27008 3.78875L4.99817 3.51676ZM8.21204 0.303865L8.48388 0.575929C8.73895 0.321065 9.16579 0.321107 9.42058 0.575846L9.69251 0.303865L9.96443 0.0318845C9.4091 -0.523338 8.49544 -0.522995 7.94019 0.0318008L8.21204 0.303865ZM9.69251 0.303865L9.42055 0.575819C9.67551 0.830776 9.67551 1.2584 9.42055 1.51336L9.69251 1.78531L9.96446 2.05726C10.5198 1.50191 10.5198 0.587261 9.96446 0.0319116L9.69251 0.303865ZM9.69251 1.78531L9.42055 1.51336L6.20766 4.72625L6.47962 4.9982L6.75157 5.27015L9.96446 2.05726L9.69251 1.78531ZM6.47962 4.9982L6.20766 5.27015L9.42055 8.48305L9.69251 8.21109L9.96446 7.93914L6.75157 4.72625L6.47962 4.9982ZM9.69251 8.21109L9.42055 8.48305C9.67551 8.738 9.67551 9.16563 9.42055 9.42058L9.69251 9.69254L9.96446 9.96449C10.5198 9.40914 10.5198 8.49449 9.96446 7.93914L9.69251 8.21109ZM9.69251 9.69254L9.42057 9.42056C9.28679 9.55432 9.12078 9.61552 8.95219 9.61555L8.95227 10.0002L8.95235 10.3848C9.31445 10.3847 9.67923 10.2497 9.96444 9.96451L9.69251 9.69254ZM8.95227 10.0002V9.61555C8.7839 9.61555 8.61783 9.55432 8.48389 9.42048L8.21204 9.69254L7.94018 9.96459C8.22528 10.2495 8.58999 10.3848 8.95227 10.3848V10.0002ZM8.21204 9.69254L8.48399 9.42058L5.27012 6.20672L4.99817 6.47867L4.72622 6.75062L7.94008 9.96449L8.21204 9.69254ZM4.99817 6.47867L4.72617 6.20676L1.51328 9.42062L1.78528 9.69254L2.05727 9.96445L5.27016 6.75058L4.99817 6.47867ZM1.78528 9.69254L1.50411 9.43012C1.39292 9.54926 1.22188 9.61548 1.04487 9.61555L1.04504 10.0002L1.04522 10.3848C1.39881 10.3846 1.78669 10.2547 2.06644 9.95496L1.78528 9.69254ZM1.04504 10.0002V9.61555C0.876053 9.61555 0.709392 9.55419 0.575787 9.42058L0.303834 9.69254L0.0318803 9.96449C0.3174 10.25 0.683146 10.3848 1.04504 10.3848V10.0002ZM0.303834 9.69254L0.575814 9.42061C0.320867 9.16561 0.320881 8.73795 0.575787 8.48305L0.303834 8.21109L0.0318803 7.93914C-0.523471 8.49449 -0.52336 9.40914 0.0318532 9.96446L0.303834 9.69254ZM0.303834 8.21109L0.575787 8.48305L3.78868 5.27015L3.51672 4.9982L3.24477 4.72625L0.0318803 7.93914L0.303834 8.21109ZM3.51672 4.9982L3.78868 4.72625L0.575787 1.51336L0.303834 1.78531L0.0318803 2.05726L3.24477 5.27015L3.51672 4.9982ZM0.303834 1.78531L0.575787 1.51336C0.320873 1.25844 0.320862 0.830788 0.57581 0.575795L0.303834 0.303865L0.0318571 0.0319349C-0.523376 0.587263 -0.523471 1.50191 0.0318803 2.05726L0.303834 1.78531ZM0.303834 0.303865L0.575787 0.575819C0.830745 0.320861 1.25837 0.320861 1.51333 0.575819L1.78528 0.303865L2.05723 0.0319116C1.50188 -0.523438 0.58723 -0.523438 0.0318803 0.0319116L0.303834 0.303865ZM1.78528 0.303865L1.51333 0.575819L4.72622 3.78871L4.99817 3.51676L5.27012 3.2448L2.05723 0.0319116L1.78528 0.303865ZM4.99817 3.51676L5.27008 3.78875L8.48395 0.57586L8.21204 0.303865L7.94012 0.0318703L4.72626 3.24476L4.99817 3.51676Z" fill="white" mask="url(#path-1-inside-1_1030_1913)" />
                                  </svg>
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div className='header-table-filters advanced-table-filters'>
                              <div className='left-area'>
                                <div className='filter-box'>
                                  <div className='searchbox'>
                                    <TextField
                                      fullWidth
                                      hiddenLabel
                                      size="small"
                                      name='search'
                                      variant="standard"
                                      placeholder="Search workflows..."
                                      value={searchText}
                                      onChange={(e) => setSearchText(e.target.value)}
                                    />
                                    <i className='icon'>
                                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.82319 10.6464C3.16455 10.6464 1 8.48183 1 5.82319C1 3.16455 3.16455 1 5.82319 1C8.48183 1 10.6464 3.16455 10.6464 5.82319C10.6464 8.48183 8.48183 10.6464 5.82319 10.6464ZM5.82319 1.70583C3.55041 1.70583 1.70583 3.55511 1.70583 5.82319C1.70583 8.09127 3.55041 9.94055 5.82319 9.94055C8.09597 9.94055 9.94055 8.09127 9.94055 5.82319C9.94055 3.55511 8.09597 1.70583 5.82319 1.70583Z" fill="#505258" stroke="#505258" stroke-width="0.236842" />
                                        <path d="M13.3182 13.7068C13.2245 13.7069 13.1307 13.6725 13.0566 13.5985L9.10425 9.63167C8.96097 9.48877 8.96065 9.25192 9.10355 9.10864C9.24646 8.96536 9.4833 8.96505 9.62658 9.10795L13.5789 13.0748C13.7222 13.2177 13.7225 13.4546 13.5796 13.5979C13.5057 13.672 13.412 13.7066 13.3182 13.7068Z" fill="#505258" stroke="#505258" stroke-width="0.236842" />
                                      </svg>
                                    </i>
                                  </div>
                                  <div className='filter-box'>
                                    <FormControl size="small" sx={{ minWidth: 120 }}>
                                      <Select
                                        value={selectedType}
                                        onChange={(e) => setSelectedType(e.target.value)}
                                        displayEmpty
                                      >
                                        <MenuItem value="all">All Types</MenuItem>
                                        <MenuItem value="custom">Custom</MenuItem>
                                        <MenuItem value="system">System</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </div>

                                </div>
                              </div>
                              <div className='right-deals-filtes style-two'>

                                <div className='filter-deals-owner' style={{ display: 'flex', gap: '5px' }}>
                                  {/* Tags Filter Button */}
                                  <button
                                    size="small"
                                    className="setting-btn mr-3"
                                    variant={selectedTags.length > 0 ? "contained" : "outlined"}
                                    // startIcon={<TagIcon />}
                                    onClick={(e) => {
                                      setTagsFilterAnchor(e.currentTarget);
                                    }}
                                  >
                                    All Tags {selectedTags.length > 0 && `(${selectedTags.length})`}
                                    <i class="fa fa-angle-down ml-2"></i>
                                  </button>
                                  <FormControl size="small" sx={{ minWidth: 120 }}>
                                    <Select
                                      value={selectedStatus}
                                      onChange={(e) => setSelectedStatus(e.target.value)}
                                      displayEmpty
                                    >
                                      <MenuItem value="all">All Status</MenuItem>
                                      <MenuItem value="active">Active</MenuItem>
                                      <MenuItem value="inactive">Inactive</MenuItem>
                                    </Select>
                                  </FormControl>
                                </div>



                                <div className='filter-table-select'>
                                  <button className={`fiters-button ${isTableView ? 'active' : ''}`} onClick={() => setTableView(true)}>
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M11.6087 13.2708H2.39199C1.27199 13.2708 0.729492 12.6992 0.729492 11.5325V9.17583C0.729492 8.00333 1.27199 7.4375 2.39199 7.4375H11.6087C12.7287 7.4375 13.2712 8.00917 13.2712 9.17583V11.5325C13.2712 12.6992 12.7287 13.2708 11.6087 13.2708ZM2.39199 8.3125C1.80283 8.3125 1.60449 8.435 1.60449 9.17583V11.5325C1.60449 12.2733 1.80283 12.3958 2.39199 12.3958H11.6087C12.1978 12.3958 12.3962 12.2733 12.3962 11.5325V9.17583C12.3962 8.435 12.1978 8.3125 11.6087 8.3125H2.39199Z" fill="currentColor" />
                                      <path d="M11.6087 6.56234H2.39199C1.27199 6.56234 0.729492 5.99067 0.729492 4.824V2.46734C0.729492 1.29484 1.27199 0.729004 2.39199 0.729004H11.6087C12.7287 0.729004 13.2712 1.30067 13.2712 2.46734V4.824C13.2712 5.99067 12.7287 6.56234 11.6087 6.56234ZM2.39199 1.604C1.80283 1.604 1.60449 1.7265 1.60449 2.46734V4.824C1.60449 5.56484 1.80283 5.68734 2.39199 5.68734H11.6087C12.1978 5.68734 12.3962 5.56484 12.3962 4.824V2.46734C12.3962 1.7265 12.1978 1.604 11.6087 1.604H2.39199V1.604Z" fill="currentColor" />
                                    </svg>
                                  </button>
                                  <button className={`fiters-button ${!isTableView ? 'active' : ''}`} onClick={() => setTableView(false)}>
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M4.82449 13.2707H2.46783C1.29533 13.2707 0.729492 12.7282 0.729492 11.6082V2.3915C0.729492 1.2715 1.30116 0.729004 2.46783 0.729004H4.82449C5.99699 0.729004 6.56283 1.2715 6.56283 2.3915V11.6082C6.56283 12.7282 5.99116 13.2707 4.82449 13.2707ZM2.46783 1.604C1.72699 1.604 1.60449 1.80234 1.60449 2.3915V11.6082C1.60449 12.1973 1.72699 12.3957 2.46783 12.3957H4.82449C5.56533 12.3957 5.68783 12.1973 5.68783 11.6082V2.3915C5.68783 1.80234 5.56533 1.604 4.82449 1.604H2.46783V1.604Z" fill="currentColor" />
                                      <path d="M11.5325 9.18734H9.17583C8.00333 9.18734 7.4375 8.64484 7.4375 7.52484V2.3915C7.4375 1.2715 8.00917 0.729004 9.17583 0.729004H11.5325C12.705 0.729004 13.2708 1.2715 13.2708 2.3915V7.52484C13.2708 8.64484 12.6992 9.18734 11.5325 9.18734ZM9.17583 1.604C8.435 1.604 8.3125 1.80234 8.3125 2.3915V7.52484C8.3125 8.114 8.435 8.31234 9.17583 8.31234H11.5325C12.2733 8.31234 12.3958 8.114 12.3958 7.52484V2.3915C12.3958 1.80234 12.2733 1.604 11.5325 1.604H9.17583V1.604Z" fill="currentColor" />
                                    </svg>
                                  </button>
                                </div>
                              </div>
                            </div>

                          )}

                          {/* Content */}
                          {workflowsLoading && allWorkflows.length === 0 ? (
                            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                              <TableAnimationFiles />
                            </Box>
                          ) : (
                            <>
                              {isTableView ? (
                                <>
                                  <style>{tableStyles}</style>
                                  <DataTable
                                    columns={columns}
                                    data={filteredWorkflows}
                                    on
                                    fixedHeader
                                    keyField="_id"
                                    selectableRows
                                    persistTableHead
                                    paginationPerPage={100}
                                    pagination={isPaginated}
                                    // progressPending={loading}
                                    clearSelectedRows={toggleCleared}
                                    fixedHeaderScrollHeight={headerScrollHeight}
                                    onSelectedRowsChange={({ selectedRows }) => setSelectedRows(selectedRows)}
                                    className={`table-sellagent table-workflow ${responsiveClass}`}
                                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                    paginationResetDefaultPage={false}
                                    onRowClicked={(menuWorkflow) => { history.push(`/agent/workflows/${menuWorkflow._id}/edit`); handleEditWorkflow(menuWorkflow); }}
                                    workflow
                                    progressComponent={<TableAnimationFiles />}
                                    noDataComponent={
                                      <div className='notfound-area'>
                                        <div className='img-box'>
                                          <img alt="..." src={notFoundImg} />
                                        </div>
                                        <p>No workflows found. Create your first workflow to get started!</p>
                                      </div>
                                    }
                                  />
                                </>
                              ) : (
                                <div className='agent-viewbox-main'>
                                  <div className="agent-container">
                                    <Masonry
                                      breakpointCols={breakpoints}
                                      className="masonry-grid"
                                      columnClassName="masonry-column"
                                    >
                                      {filteredWorkflows.map(workflow => (
                                        <WorkflowCard key={workflow._id} workflow={workflow} />

                                      ))}
                                    </Masonry>

                                  </div>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >

      {/* <Box sx={{ p: 3 }}>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
           <MenuItem onClick={() => handleExecuteWorkflow(row)} disabled={row.status !== 'active'}>
            <ListItemIcon>
              <PlayIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Execute Workflow</ListItemText>
          </MenuItem>

          <MenuItem onClick={() => handleEditWorkflow(row)}>
            <ListItemIcon>
              <EditIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Edit Workflow</ListItemText>
          </MenuItem>

          <MenuItem onClick={() => history.push(`/agent/workflows/${row._id}/schedule`)}>
            <ListItemIcon>
              <ScheduleIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Schedule Workflow</ListItemText>
          </MenuItem>
          
          <MenuItem onClick={() => {
            handleCloneWorkflow(menuWorkflow);
            handleMenuClose();
          }}>
            <ListItemIcon>
              <CopyIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Clone</ListItemText>
          </MenuItem>
          <MenuItem onClick={() => {
            handleDeleteClick(menuWorkflow);
            handleMenuClose();
          }}>
            <ListItemIcon>
              <DeleteIcon fontSize="small" color="error" />
            </ListItemIcon>
            <ListItemText>Delete</ListItemText>
          </MenuItem>
        </Menu>
      </Box> */}

      {/* Modal */}
      <Modal isOpen={cloneModal} toggle={() => setCloneModal(false)} className={`main-modal new-user-modal modal-dialog-centered workflow-modal`}>
        <ModalHeader toggle={() => setCloneModal(false)}><h3>Clone Workflow </h3></ModalHeader> 
        <ModalBody>
          <div className='content-area'> 
            <div className='form-area'>
              <div className='group-form'>
                <label>Workflow Name</label>
                <TextField
                  fullWidth
                  hiddenLabel
                  size="small"
                  type="text"
                  value={newName}
                  onChange={(e) => setNewName(e.target.value)}
                />
              </div>
              <div className='btns-box text-right'>
                <button className='btn-style-border' onClick={() => setCloneModal(false)}>Cancel</button>
                <button className='btn-style-new' onClick={handleCloneWorkflow}>Clone</button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>


      {/* Delete Confirmation Modal */}
      <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)} className={`main-modal new-user-modal modal-dialog-centered workflow-modal`}>
        <ModalHeader toggle={() => setDeleteModal(false)}>
          <h3>Confirm Delete</h3>
        </ModalHeader>
        <ModalBody>
          <div className='content-area'>
            <div className='form-area'>
              {workflowToDelete ? (
                <>
                  <p>Are you sure you want to delete the workflow "{workflowToDelete?.name}"?</p>
                  <p>This action cannot be undone.</p>
                </>
              ) : workflowsToDelete.length > 0 ? (
                <>
                  <p>Are you sure you want to delete {workflowsToDelete.length} workflow{workflowsToDelete.length > 1 ? 's' : ''}?</p>
                  <div style={{ marginTop: '10px', marginBottom: '10px' }}>
                    <strong>Workflows to delete:</strong>
                    <ul style={{ maxHeight: '150px', overflowY: 'auto', marginTop: '5px' }}>
                      {workflowsToDelete.map(w => (
                        <li key={w._id}>{w.name}</li>
                      ))}
                    </ul>
                  </div>
                  <p>This action cannot be undone.</p>
                </>
              ) : null}

              <div className='btns-box text-right'>
                <button className='btn-style-border' onClick={() => {
                  setDeleteModal(false);
                  setWorkflowToDelete(null);
                  setWorkflowsToDelete([]);
                }}>Cancel</button>
                <button className='btn-style-new' onClick={confirmDelete}>
                  Delete {workflowsToDelete.length > 0 ? `(${workflowsToDelete.length})` : ''}
                </button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      {scheduleDialog && (
        <WorkflowScheduler setScheduleDialog={setScheduleDialog} scheduleDialog={scheduleDialog} />
      )}

      {/* Tags Filter Popover */}
      <Popover
        open={Boolean(tagsFilterAnchor)}
        anchorEl={tagsFilterAnchor}
        onClose={() => setTagsFilterAnchor(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: { p: 2, minWidth: 250 }
        }}
      >
        <Box>
          <h4 className="filtst-heading"> Filter by Tags </h4>
          {workflowsObjectState?.allTags && workflowsObjectState.allTags.length > 0 ? (
            <Box className="workflow-tags" sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {workflowsObjectState.allTags.map((tag, index) => (
                <Box
                  key={index}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    backgroundColor: typeof tag === 'object' ? (tag.color || '#6B7280') : '#6B7280',
                    color: 'white',
                    p: 0.5,
                    borderRadius: 1
                  }}
                  onClick={() => {
                    const tagName = typeof tag === 'string' ? tag : tag.name;
                    setSelectedTags(prev => {
                      if (prev.includes(tagName)) {
                        return prev.filter(t => t !== tagName);
                      } else {
                        return [...prev, tagName];
                      }
                    });
                  }}
                >
                  <Checkbox
                    size="small"
                    sx={{ color: 'white', }}
                    checked={selectedTags.includes(typeof tag === 'string' ? tag : tag.name)}
                  />
                  <Chip
                    label={typeof tag === 'string' ? tag : tag.name}
                    size="small"
                    sx={{
                      backgroundColor: typeof tag === 'object' ? (tag.color || '#6B7280') : '#6B7280',
                      color: 'white',
                      // ml: 1
                    }}
                  />
                </Box>
              ))}
              {selectedTags.length > 0 && (
                <Button
                  size="small"
                  onClick={() => setSelectedTags([])}
                  sx={{ mt: 1, textTransform: 'none' }}
                >
                  Clear All
                </Button>
              )}
            </Box>
          ) : (
            <Typography variant="body2" color="textSecondary">
              No tags available
            </Typography>
          )}
        </Box>
      </Popover>

    </>
  );
};

const tableStyles = `
          .table-sellagent input[type="checkbox"] {
            width: 13px;
          height: 13px;
          cursor: pointer;
          accent-color: #cbd6e2;
          transform: scale(1);
          opacity: 0.45;
  }

          .table-sellagent input[type="checkbox"]:checked {
            opacity: 1;
          accent-color: var(--primary-color);
  }

          .rdt_TableRow {
            transition: background-color 0.15s ease;
  }

          .rdt_TableRow:hover {
            background - color: #f5f5f5;
  }

          .table-container {
            position: relative;
  }
          `;

export default Workflows;